import React, {useState} from 'react'
import FetchUtil from "../util/FetchUtil";
import ConfigUtil from "../util/ConfigUtil";
import ErrorInfoComponent from "./general/ErrorInfoComponent";
import DHDefaultDrawer from "./general/DHDefaultDrawer";
import DHButtonClose from "./general/DHButtonClose";
import DHTextField from "./general/DHTextField";
import DHButtonDefault from "./general/DHButtonDefault";
import DHPasswordField from "./general/DHPasswordField";
import {PrimeIcons} from "primereact/api";

export default function ZugangVergessenDialog({onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [phase, setPhase] = useState(1);
    const [email, setEmail] = useState("");
    const [username, setUsername] = useState("");
    const [password1, setPassword1] = useState("");
    const [password2, setPassword2] = useState("");
    const [code, setCode] = useState("");
    const [tabValue, setTabValue] = useState("KENNWORT");

    const handelKeyDown = (e) => {
        if (e.keyCode === 13) {
            // enter
            if (phase === 1) {
                postPhase1();
            } else if (phase === 2) {
                postPhase2();
            }
            if (phase === 3) {
                postPhase3();
            }

        }
    }

    const benutzernameAnfordern = () => {
        setErrorMessage(undefined);
        let data = {email: email};
        let url = ConfigUtil.getConfig().resourceUrls.user + "/usernamevergessen";
        FetchUtil.fetchPost(url,
            data,
            (message) => {
                if (message !== null && message !== undefined && message !== "") {
                    setErrorMessage(message);
                } else {
                    setInfoMessage("Benutzername wurde angefordert.");
                    setEmail("");
                }
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const postPhase3 = () => {
        setErrorMessage(undefined);
        let date = {password1: password1, password2: password2};
        let url = ConfigUtil.getConfig().resourceUrls.user + "/kennwortvergessenchangepassword?code=" + code;
        FetchUtil.fetchPost(url,
            date,
            json => {
                setPhase(4);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const postPhase2 = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.user + "/kennwortvergessencodeueberpruefen?code=" + code;
        FetchUtil.fetchPost(url,
            {},
            json => {
                setPhase(3);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const postPhase1 = () => {
        setErrorMessage(undefined);
        let url = ConfigUtil.getConfig().resourceUrls.user + "/kennwortvergessencodeanfordern?param=" + username;
        FetchUtil.fetchPost(url,
            {},
            json => {
                setPhase(2);
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            }
        );
    }

    const getKennwortVergessenPhase2Area = () => {
        if (phase !== 2) {
            return "";
        }
        return <div>
            <h1>Überprüfung deiner Identität</h1>
            Aus Sicherheitsgründen müssen wir deine Identität überprüfen. Sofern wir zu deinen Daten ein Konto gefunden haben, haben wir dir einen Code an deine Emailadresse geschickt. Gib diesen
            bitte unten ein.
            <br/><br/>Code eingeben
            <div className="col-12 md:col-12 lg:col-8">
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 10}}>
                        <DHTextField id="id-code" label="Code" width={"100%"}
                                     value={code} onChange={(text) => setCode(text)}
                                     onKeyDown={(e) => handelKeyDown(e)} />
                    </div>
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 5}}>
                        <DHButtonDefault label="Weiter" onClick={() => postPhase2()} disabled={!code} style={{marginRight:5}}/>
                        <DHButtonClose onClick={() => onClose()}/>
                    </div>
                </div>
            </div>
            Sofern du keine Mail erhalten hast (prüfe bitte auch den SPAM Ordner), nimm bitte Kontakt mit unserem Support auf.
        </div>
    }

    const getKennwortVergessenPhase4Area = () => {
        if (phase !== 4) {
            return "";
        }
        return <div>
            <h1>Super...</h1>
            Dein Kennwort wurde geändert, du kannst dich nun mit deinem Benutzernamen und deinem Kennwort anmelden.
            <br/>
            <br/>
            Sofern du weiter Probleme hast, nimm Kontakt mit unserem Support auf.
            <div style={{marginTop:10}}>
                <DHButtonClose onClick={() => onClose()}/>
            </div>
        </div>
    }

    const getKennwortVergessenPhase3Area = () => {
        if (phase !== 3) {
            return "";
        }
        return <div>
            <h1>Neues Passwort erstellen</h1>
            Gib hier deine E-Mail-Adresse oder deinen Benutzernamen ein.
            <div className="col-12 md:col-12 lg:col-8">
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 10}}>
                        <DHPasswordField id="id-kennwort" value={password1}
                                         onChange={(text) => setPassword1(text)}
                                         onKeyDown={(e) => handelKeyDown(e)}
                                         width={"100%"} label="Kennwort" required={true} disabled={false}/>
                    </div>
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 10}}>
                        <DHPasswordField id="id-kennwort2" value={password2}
                                         onChange={(text) => setPassword2(text)}
                                         onKeyDown={(e) => handelKeyDown(e)}
                                         width={"100%"} label="Kennwort wiederholen" required={true} disabled={false}/>
                    </div>
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 5}}>
                        <DHButtonDefault label="Weiter" onClick={() => postPhase3()} disabled={!password1 && !password2} style={{marginRight:5}}/>
                        <DHButtonClose onClick={() => onClose()}/>
                    </div>
                </div>
            </div>
        </div>
    }

    const getBenutzernameVergessenArea = () => {
        return <div  style={{padding:20}}>
            Benutzername vergessen?<br/>
            Gib hier deine E-Mail-Adresse ein, wir senden dir den Benutzernamen zu.
            <div className="col-12 md:col-12 lg:col-8">
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 10}}>
                        <DHTextField id="id-benutzername-email" label="Emailadresse" width={"100%"}
                                     value={email} onChange={(text) => setEmail(text)}
                                     onKeyDown={(e) => handelKeyDown(e)} />
                    </div>
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 5}}>
                        <DHButtonDefault label="Anfordern" onClick={() => benutzernameAnfordern()} disabled={!email} style={{marginRight:5}}/>
                        <DHButtonClose onClick={() => onClose()}/>
                    </div>
                </div>
            </div>
        </div>
    }


    const getKennwortVergessenPhase1Area = () => {
        if (phase !== 1) {
            return "";
        }
        return <div>
            Kennwort vergessen?<br/>
            Gib hier deine E-Mail-Adresse oder deinen Benutzernamen ein.
            <div className="col-12 md:col-12 lg:col-8">
                <div className="grid">
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 10}}>
                        <DHTextField id="id-username" label="Benutzername oder Emailadresse" width={"100%"}
                                     value={username} onChange={(text) => setUsername(text)}
                                     onKeyDown={(e) => handelKeyDown(e)} />
                    </div>
                    <div className="col-12 md:col-6 lg:col-12" style={{marginTop: 5}}>
                        <DHButtonDefault label="Weiter" onClick={() => postPhase1()} disabled={!username} style={{marginRight:5}}/>
                        <DHButtonClose onClick={() => onClose()}/>
                    </div>
                </div>
            </div>
        </div>
    }

    const erzeugeTab = (value, key, icon, width, color) => {
        return <div style={{
            fontSize: 20, width: width,
            marginTop: 5,
            marginLeft: 5, cursor: "pointer",
            borderBottom: tabValue === key ? "2px solid red" : "none", textAlign: "center"
        }}
                    onClick={() => setTabValue(key)}>

            <i className={icon}
               style={{fontSize: 20, marginLeft: 5, marginRight: 5, color: color ? color : "white", cursor: "pointer"}}/><br/>
            {value.toUpperCase()}
        </div>
    }

    const getTabs = () => {
        let returnValue = [];
        returnValue.push(erzeugeTab("Kennwort", "KENNWORT", PrimeIcons.PLUS, 150));
        returnValue.push(erzeugeTab("Benutzername", "BENUTZERNAME", PrimeIcons.PLUS, 150));
        return returnValue;
    }

    const kennwortVergessenTab = () => {
        return <div className="col-12 md:col-12 lg:col-12" style={{marginTop:20}}>
            {getKennwortVergessenPhase1Area()}
            {getKennwortVergessenPhase2Area()}
            {getKennwortVergessenPhase3Area()}
            {getKennwortVergessenPhase4Area()}
        </div>
    }

    const getTabpanel = () => {
        if (tabValue === "KENNWORT") {
            return kennwortVergessenTab();
        } else if (tabValue === "BENUTZERNAME") {
            return getBenutzernameVergessenArea();
        }
        return <></>
    }

    return <DHDefaultDrawer title="Zugang vergessen" onClose={() => onClose()} show={true} children={<div style={{padding: 20}}>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div style={{display: "flex", flexWrap: "nowrap"}}>
            {getTabs()}
        </div>
        {getTabpanel()}
    </div>}/>
}